import { Injectable } from '@angular/core';
import { VersionCheckService } from 'ngx-version-check';
import { UtilsService } from './utils.service';
import { NEW_VERSION_DIALOG_WITH, NewVersionDialogComponent } from '@shared/new-version-dialog/new-version-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class NewVersionCheckerService {
  constructor(
    private readonly versionCheckService: VersionCheckService,
    private readonly utilsService: UtilsService
  ) {}

  startChecking() {
    this.versionCheckService.startVersionChecking({
      frequency: 30000,
      notification: () => {
        this.openUpdateDialog();
      },
    });
  }

  async openUpdateDialog() {
    await this.utilsService.openResponsiveDialog<NewVersionDialogComponent, {}, boolean>({
      component: NewVersionDialogComponent,
      inputData: {},
      width: NEW_VERSION_DIALOG_WITH,
      autoFocus: false,
      disableClose: true,
    });
  }
}
